import { getPolicyTypeFromTraditionalLTCQuote } from '@shared/getPolicyTypeFromTraditionalLTCQuote';
import { defaultsRetroactiveWaitingPeriodReimbursement } from '@shared';
import { parseBioPercentToInflationRate } from '@/util/policyQuoteCalculations';

export function getPremiumCostPerMonth(traditionalQuote: TraditionalLTCQuote): number {
  switch (traditionalQuote.premiumFrequency) {
    case 'Monthly':
      return traditionalQuote.primaryModalPremium;
    case 'Annually':
      return traditionalQuote.primaryModalPremium / 12;
    default:
      return traditionalQuote.primaryModalPremium / 12;
  }
}

export function createTraditionalLTCFundingSource(
  quote: TraditionalLTCQuote,
  advisorId: string | undefined,
  isAdvisorSession: boolean,
  addedViaShopInsurance: boolean,
) {
  const inflationRate = parseBioPercentToInflationRate(quote.bioPercent);
  const policyType = getPolicyTypeFromTraditionalLTCQuote(quote);

  return {
    carrierName: quote.carrier,
    hasPolicyFunding: true,
    isSimpleInflationProtection: false,
    addedByAdvisorId: isAdvisorSession ? advisorId : undefined,
    isIndemnityPolicyPayment: false,
    policyBenefitIsUnlimited: false,
    policyMaximumBenefitAmount: quote.benefitPool,
    policyPremiumMonthlyCost: getPremiumCostPerMonth(quote),
    policyPremiumStartYear: new Date().getFullYear(),
    policyInflationProtection: inflationRate,
    policyLumpSumPayment: null,
    dailyHomeBenefitAmount: quote.dailyBenefitAmount,
    dailyHomeInflationProtectionPercent: null,
    dailyIndependentLivingBenefitAmount: quote.dailyBenefitAmount,
    dailyIndependentLivingInflationProtectionPercent: null,
    dailyAssistedLivingBenefitAmount: quote.dailyBenefitAmount,
    dailyAssistedLivingInflationProtectionPercent: null,
    dailyNursingHomeBenefitAmount: quote.dailyBenefitAmount,
    dailyNursingHomeInflationProtectionPercent: null,
    homeCareWaitingPeriodDays: quote.eliminationPeriod,
    facilityCareWaitingPeriodDays: quote.eliminationPeriod,
    hasRetroactiveWaitingPeriodReimbursement: defaultsRetroactiveWaitingPeriodReimbursement(policyType)
      ? true
      : null,
    policyLimitedPayYears: null,
    policyBenefitPeriodMonths: null,
    policyMonthlyWithdrawalRate: null,
    policyPremiumIncreaseRate: null,
    policyPremiumIncreaseYears: null,
    policyInflationProtectionOnFaceAmount: null,
    policyInflationProtectionOnCOBAmount: null,
    policyInflationProtectionYears: null,
    policyBenefitUtilizedToDate: 0,
    policyContinuationBenefitAmount: null,
    policyMinimumGuaranteedBenefitAmount: null,
    customPolicyId: quote.traditionalLTCQuoteId,
    addedViaShopInsurance,
    insuranceQuoteId: quote.traditionalLTCQuoteId,
    sourceQuote: quote,
    policyType,
    policyAddedAt: Date.now(),
  };
}
